import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 90000,
  withCredentials: true,  // Phase 7 — carry the dom_session httpOnly cookie
});

// Phase 7 — auto-redirect to /login on any 401 from /api/*.
// Preserves the original URL so post-login we can bounce back.
let _redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Skip redirect if the 401 is from the /auth/* surface itself — the
    // login page renders its own error state.
    const isAuthSurface = /\/auth\//.test(url);
    if (status === 401 && !isAuthSurface && !_redirecting &&
        typeof window !== "undefined") {
      _redirecting = true;
      const here = window.location.pathname + window.location.search;
      if (!here.startsWith("/login")) {
        const next = encodeURIComponent(here);
        window.location.replace(`/login?next=${next}`);
      }
    }
    return Promise.reject(err);
  }
);

// Absolute URL helper for <img>/<video> src when the backend returns a path like /api/...
export const absUrl = (apiPath) => {
  if (!apiPath) return null;
  if (apiPath.startsWith("http")) return apiPath;
  return `${BACKEND_URL}${apiPath}`;
};
